// @Deprecated : remove when we remove the classic version

// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import DataTable from '../../../components/data/DataTable';
import { LoadingSpinner } from '../../../components/common';
import DisclaimerFooter from '../../../components/disclaimers/DisclaimerFooter';

// Utils
import { GenericEmptyState } from '../../../components/misc';
import AdvancedSearchItem from '@/types/advanced-search-item';

type DispatchProps = {
  onSelectItems: (ids: string[]) => void;
  onUnselectItems: (ids: string[]) => void;
};

type StateProps = {
  className?: string;
  data: any[];
  columns: any[];
  actions?: JSX.Element[];
  loading: boolean;
  selected: AdvancedSearchItem[];
  selectedTitle?: string;
  emptyResultsAction?: () => void;
  emptyResultsActionLabel?: string;
  emptyResultsActionIcon?: string;
  noDataTitle: string;
  noDataBodyText?: string;
  noResultsTitle: string;
  noResultsBodyText?: string;
  disclaimers?: string[];
};

type Props = DispatchProps &
  StateProps & {
    query?: string;
  };

const SavedItemsTable = ({ ...props }: Props) => {
  const {
    loading,
    query,
    columns,
    data,
    actions,
    selected,
    selectedTitle,
    className,
    noDataTitle,
    noDataBodyText,
    noResultsTitle,
    noResultsBodyText,
    emptyResultsAction,
    emptyResultsActionIcon,
    emptyResultsActionLabel,
    disclaimers,
  } = props;

  return (
    <div className={classNames('saved-items-table', className)}>
      {loading && <LoadingSpinner />}

      {/* No data at all */}
      {!loading && data.length === 0 && !query && (
        <GenericEmptyState
          header={noDataTitle}
          body={noDataBodyText}
          onAction={emptyResultsAction}
          actionLabel={emptyResultsActionLabel}
          actionIcon={emptyResultsActionIcon}
        />
      )}

      {/* No data matching query */}
      {!loading && data.length === 0 && query && <GenericEmptyState header={noResultsTitle} body={noResultsBodyText} />}

      {data.length > 0 && (
        <>
          <DataTable
            className={classNames(className, { hidden: loading })}
            columns={columns}
            data={data}
            canSelect
            selected={selected}
            onSelectItems={props.onSelectItems}
            onUnselectItems={props.onUnselectItems}
            sortable
            selectedTitle={selectedTitle}
            selectedActions={actions}
          />
          {disclaimers && <DisclaimerFooter disclaimers={disclaimers} />}
        </>
      )}
    </div>
  );
};

export default SavedItemsTable;
